import { UserGroupIcon } from '@heroicons/react/24/outline';
import { getTeamColor } from '@odo/shared-ui/components/teamColors';

interface TeamColorTileProps {
    name: string;
    size?: 'sm' | 'md';
}

const SIZE_CLASS: Record<'sm' | 'md', { box: string; icon: string }> = {
    sm: { box: 'w-8 h-8', icon: 'h-4 w-4' },
    md: { box: 'w-10 h-10', icon: 'h-5 w-5' }
};

// Same deterministic palette as chat's TeamSelector/TeamPill, tinted to a
// translucent background so the icon (not a filled chip) carries the color.
export function TeamColorTile({ name, size = 'sm' }: TeamColorTileProps) {
    const color = getTeamColor(name);
    const { box, icon } = SIZE_CLASS[size];

    return (
        <span
            aria-hidden="true"
            className={`inline-flex items-center justify-center rounded-lg shrink-0 ${box}`}
            style={{ backgroundColor: `${color}1f`, color }}
        >
            <UserGroupIcon className={icon} />
        </span>
    );
}
